/**
 * @author piotrzurek
 * @since 2021-10-12
 */

import * as React from "react";
import styled from "styled-components";

import { Button } from "@ui/Atoms";

interface Props {
  className?: string;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  onLeftButtonClick?: (e: React.SyntheticEvent) => void;
  onRightButtonClick?: (e: React.SyntheticEvent) => void;
}

const DoubleButton = (props: Props): React.ReactElement => (
  <DoubleButtonWrapper className={props.className}>
    <LeftButton
      type={"button"}
      variant={"white"}
      onClick={props.onLeftButtonClick}
    >
      {props.leftContent}
    </LeftButton>
    <RightButton
      type={"button"}
      variant={"green"}
      onClick={props.onRightButtonClick}
    >
      {props.rightContent}
    </RightButton>
  </DoubleButtonWrapper>
);

DoubleButton.displayName = "DoubleButton";

export { DoubleButton };

const DoubleButtonWrapper = styled.div`
  display: grid;
  gap: ${props => props.theme.margins.base};

  ${props => props.theme.breakpoints.tablet} {
    grid-template-columns: 1fr auto;
    gap: 0;
  }
`;

const LeftButton = styled(Button)`
  text-align: left;
  color: ${props => props.theme.palette.grey600};
  font-weight: ${props => props.theme.fonts.weights.normal};

  ${props => props.theme.breakpoints.tablet} {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
`;

const RightButton = styled(Button)`
  ${props => props.theme.breakpoints.tablet} {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
`;
